import { Enums } from '@utils/constants';
import { axios } from '@utils/lib';
import { FC, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import './AuthImage.scss';
import { Avatar } from '@mui/material';

interface AuthImageProps {
  src: string;
  alt?: string;
  className?: string;
  avatar?: boolean;
}

const AuthImage: FC<AuthImageProps> = ({
  src,
  alt,
  className,
  avatar = false,
}) => {
  const { id, db } = useParams();

  const [imgSrc, setImgSrc] = useState<string>();

  useEffect(() => {
    fetchSrc();
  }, []);

  async function fetchSrc() {
    try {
      const { data } = await axios.request<Blob>(
        Enums.HTTP_METHOD.GET,
        `applications/${id}/private-dbs/${db}/private-id/${src}`,
        undefined,
        { responseType: 'blob' },
      );

      const objectURL = URL.createObjectURL(data);
      setImgSrc(objectURL);
    } catch (error) {
      console.error('Error fetching image:', error);
    }
  }

  return avatar ? (
    <Avatar className={className} src={imgSrc} alt={alt} />
  ) : (
    <img className={className} src={imgSrc} alt={alt} loading="lazy" />
  );
};

export default AuthImage;
